import { type FC, type PropsWithChildren } from 'react';
import { useSocketIo } from '@common/socket/socket-io';

import { TonConnectProvider } from '@/components/TonConnect/TonConnectProvider/TonConnectProvider';

const Providers: FC<PropsWithChildren> = ({ children }) => {
  useSocketIo();

  return <TonConnectProvider>{children}</TonConnectProvider>;
};

export { Providers };
